import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },{
    path: '/a',
    name: 'Anything',
    component: () => import('../views/A.vue')
  },{
    path: '/projects',
    name: 'Projects',
    component: () => import('../views/Projects.vue')
  },{
    path: '/projects/monster-diagram',
    name: 'Monster Diagram',
    component: () => import('../views/MonsterDiagram.vue')
  },{
    path: '/suhc',
    name: 'SUHC',
    component: () => import('../views/SUHC.vue'),
    children: [
      { path: 'log', name: 'Captain\'s log | SUHC', component: () => import('../views/SUHC-Log.vue') },
      { path: 'quotes', name: 'Quotes | SUHC', component: () => import('../views/SUHC-Quotes.vue') }
    ]
  },{
    path: '/l/admin',
    name: 'Administrare Literatură',
    component: () => import('../views/LiteratureAdmin.vue')
  },{
    path: '/l/:category?/:subPath?',
    name: 'Literature',
    props: true,
    component: () => import('../views/Literature.vue')
  },{
    path: '/graph',
    name: 'Graph',
    props: true,
    component: () => import('../views/Graph.vue')
  },{
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },{
    path: '/playlist/:indexKey/:playlist',
    name: 'Playlist',
    props: true,
    component: () => import('../views/Playlist.vue')
  },{
    path: '/banned',
    name: 'Banned & Recommended',
    component: () => import('../views/Banned.vue')
  },{
    path: '/more-writing/:filename',
    name: 'More Essays',
    props: true,
    component: () => import('../views/Writings.vue')
  },{
    path: '/bus',
    name: 'Buses',
    component: () => import('../views/Buses.vue')
  },{

//    path: '/diary/editor',
//    name: 'Editor | Diary',
//    component: () => import('../views/Editor.vue')
//  },{
//    path: '/diary/docview',
//    name: 'Doc View | Diary',
//    component: () => import('../views/Docview.vue')
//  },{
    path: '/goldmine',
    name: 'Gold Mine | Diary',
    component: () => import('../views/Gagmine.vue')
  },{
    path: '/perle-zicale/:specialSet',
    name: 'Perle și Zicale',
    props: true,
    component: () => import('../views/Gagmine.vue')
  },{
    path: '/essay/:filename?',
    name: 'Redirecting to Essays',
    props: {target: '/l/Eseuri'}, // TODO Preserve subpaths / query data from URL
    component: () => import('../views/Redirection.vue')
  },{
    path: '/diagram',
    name: 'Redirecting to Monster Diagram',
    props: {target: '/projects/monster-diagram'},
    component: () => import('../views/Redirection.vue')

  },{
    path: '*',
    name: '404',
    component: () => import('../views/404.vue')
  }
]

const router = new VueRouter({
//  mode: 'history',
  routes
})
router.afterEach((to, from) => {
  document.title = to.name + ' | ' + Vue.prototype.$interpretedHost;
});

export default router
